module.exports = __webpack_public_path__ + "static/media/arch.2c8575e7.png";